const ServicesSection = () => {
  const services = [
    {
      title: "Custom Resin Art",
      description: "Personalized resin pieces crafted to your specifications and style preferences.",
      image: "/placeholder.svg?height=300&width=400",
    },
    {
      title: "Handmade Passion",
      description: "Each piece is carefully handcrafted with attention to detail and artistic flair.",
      image: "/placeholder.svg?height=300&width=400",
    },
    {
      title: "Unique Designs",
      description: "One-of-a-kind designs that reflect your personality and creative vision.",
      image: "/placeholder.svg?height=300&width=400",
    },
  ]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">Our Customization Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Overview of customization services available. Encourage visitors to explore custom orders.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="bg-gray-200 rounded-lg aspect-[4/3] mb-4 overflow-hidden">
                <img
                  src={service.image || "/placeholder.svg"}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesSection
